import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Settlement } from 'ha/services/apiV2/types/Settlement';

export default (makeCall: MakeCall) => (reference: string) =>
  makeCall<Settlement>('GET', `/api/v2/payment/settlement/${reference}`);
